import React from 'react'
import styled from 'styled-components'

const ContactMe = () => {

    const WrapperInput = styled.div`
    display:flex;
    justify-content:center;
    margin-top: 50px;
    `

    const InputContainer = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90vw;
    text-align: center;
    `

    const Label = styled.label`
     font-family: 'Nuosu SIL', serif;
    font-weight: 400;
    /* text-transform: uppercase; */
    font-size: 20px;
    margin-bottom: 10px;
    `

    const Textarea = styled.textarea`
    font-family: 'Heebo', sans-serif;
    width: 70vw;
    height: 100px;
    resize: none;
    margin-bottom: 10px;
    padding: 10px;
    border: .3px solid black;
    border-radius: 5px;
    `

    const Button = styled.button`
     font-family: 'Nuosu SIL', serif;
    margin-bottom: 100px;
    padding: 8px;
    background-color: transparent;
    border-top: 0;
    border-right:0ch;
    border-bottom: 0.3px solid black;
    border-left: 0;
   
    cursor: pointer;

    &:hover {
        background-color: yellow;
        font-style: italic;
    }
    `

    return(

        <WrapperInput>
            <InputContainer>
            <Label>Please tell:</Label>
            <Textarea></Textarea>
            <Button type="submit">Let me know</Button>
            </InputContainer>
        </WrapperInput>
    )
}

export default ContactMe